var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 124,
    viewBox: "0 0 130 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 123.5,
    r: 123.5,
    fill: "#4452E3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 123.5,
    r: 123.5,
    fill: "url(#pattern0_140_7169)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_140_7169",
    patternUnits: "userSpaceOnUse",
    patternTransform: "matrix(45.6678 0 0 53.4373 -117 172.782)",
    preserveAspectRatio: "none",
    viewBox: "-0.000167847 0 163.099 190.848",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pattern0_140_7169_inner",
    transform: "translate(-163.099 -190.848)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pattern0_140_7169_inner",
    transform: "translate(0 -190.848)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pattern0_140_7169_inner",
    transform: "translate(-163.099 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "pattern0_140_7169_inner"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.1034 169.716C53.0534 169.206 52.0734 157.056 57.3234 151.756C61.4934 147.516 93.9334 129.696 107.683 122.226C110.123 120.896 114.463 120.416 117.223 121.976L152.383 142.546C156.163 144.686 156.773 148.416 156.863 152.126L158.523 223.016C158.623 227.926 156.133 232.426 152.023 234.766L101.903 263.446C100.013 264.536 97.9234 265.076 95.8534 265.066C93.8034 265.066 91.7634 264.536 89.9034 263.486L74.9934 256.336L74.0634 185.146C74.0334 182.806 72.7334 180.706 70.6534 179.636L53.1534 170.216L53.1134 169.706L53.1034 169.716Z",
    fill: "#E3E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1034 169.716C53.0534 169.206 52.0734 157.056 57.3234 151.756C61.4934 147.516 93.9334 129.696 107.683 122.226C110.123 120.896 114.463 120.416 117.223 121.976L152.383 142.546C156.163 144.686 156.773 148.416 156.863 152.126L158.523 223.016C158.623 227.926 156.133 232.426 152.023 234.766L101.903 263.446C100.013 264.536 97.9234 265.076 95.8534 265.066C93.8034 265.066 91.7634 264.536 89.9034 263.486L74.9934 256.336L74.0634 185.146C74.0334 182.806 72.7334 180.706 70.6534 179.636L53.1534 170.216L53.1134 169.706L53.1034 169.716Z",
    fill: "#DDE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.103451 48.7159C0.0534481 48.2059 -0.926549 36.0559 4.32345 30.7559C8.49345 26.5159 40.9335 8.69571 54.6835 1.22571C57.1235 -0.104289 61.4634 -0.584189 64.2234 0.975711L99.3835 21.5459C103.163 23.6859 103.773 27.4159 103.863 31.1259L105.523 102.016C105.623 106.926 103.133 111.426 99.0235 113.766L48.9035 142.446C47.0135 143.536 44.9235 144.076 42.8535 144.066C40.8035 144.066 38.7635 143.536 36.9035 142.486L21.9935 135.336L21.0635 64.1459C21.0335 61.8059 19.7335 59.7059 17.6535 58.6359L0.153454 49.2159L0.113461 48.7059L0.103451 48.7159Z",
    fill: "#DDE0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.423 48.7159C226.473 48.2059 227.453 36.0559 222.203 30.7559C218.033 26.5159 185.593 8.69571 171.843 1.22571C169.403 -0.104289 165.063 -0.584189 162.303 0.975711L127.143 21.5459C123.363 23.6859 122.753 27.4159 122.663 31.1259L121.003 102.016C120.903 106.926 123.393 111.426 127.503 113.766L177.623 142.446C179.513 143.536 181.603 144.076 183.673 144.066C185.723 144.066 187.763 143.536 189.623 142.486L204.533 135.336L205.463 64.1459C205.493 61.8059 206.793 59.7059 208.873 58.6359L226.373 49.2159L226.413 48.7059L226.423 48.7159Z",
    fill: "#E3E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.423 48.7159C226.473 48.2059 227.453 36.0559 222.203 30.7559C218.033 26.5159 185.593 8.69571 171.843 1.22571C169.403 -0.104289 165.063 -0.584189 162.303 0.975711L127.143 21.5459C123.363 23.6859 122.753 27.4159 122.663 31.1259L121.003 102.016C120.903 106.926 123.393 111.426 127.503 113.766L177.623 142.446C179.513 143.536 181.603 144.076 183.673 144.066C185.723 144.066 187.763 143.536 189.623 142.486L204.533 135.336L205.463 64.1459C205.493 61.8059 206.793 59.7059 208.873 58.6359L226.373 49.2159L226.413 48.7059L226.423 48.7159Z",
    fill: "#C3C8FF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.8bd7564cc010dd9c7fc14f6ae44ebcd0.svg";
export { ForwardRef as ReactComponent };